module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-06-9652e0d6ba6f1e57a9bfc7a6b85e9255.svg";